import { POST_NOTIFICACION, POST_NOTIFICACION_FAIL, POST_NOTIFICACION_SUCCESS, PUT_NOTIFICACION, PUT_NOTIFICACION_FAIL, PUT_NOTIFICACION_SUCCESS, RESET_PORTAL_CONTEXT, SET_ALERTA_MODAL, SET_ALERTA_MODAL_DELETE } from "../ActionTypes";
import notificaionInitialState from "../initialStates/notificacion";

const notificacionesReducer = (state, { payload, type }) => {
  switch (type) {
    case POST_NOTIFICACION:
        return {
            ...state, 
            notificaciones: {
                ...state.notificaciones,
                loading: true, 
                data: false, 
                error: false 
            }
        }
    case POST_NOTIFICACION_SUCCESS:
        return {
            ...state, 
            notificaciones: {
                ...state.notificaciones,
                loading: false, 
                data: payload, 
                error: false 
            }
        }
    case POST_NOTIFICACION_FAIL: 
    return {
        ...state, 
        notificaciones: {
                ...state.notificaciones,
                loading: true, 
                data: false, 
                error: true 
            }
    }
    case PUT_NOTIFICACION:
        return {
            ...state, 
            notificaciones: {
                ...state.notificaciones,
                loading: true, 
                data: state.notificaciones.data, 
                error: false 
            }
        }
    case PUT_NOTIFICACION_SUCCESS:
        return {
            ...state, 
            notificaciones: {
                ...state.notificaciones,
                loading: false, 
                data: state.notificaciones.data, 
                error: false 
            }
        }
    case PUT_NOTIFICACION_FAIL: 
        return {
            ...state, 
            notificaciones: {
                    ...state.notificaciones,
                    loading: true, 
                    data: state.notificaciones.data, 
                    error: true 
                }
        }
    case SET_ALERTA_MODAL: 
        return {
            ...state, 
            notificaciones: {
                ...state.notificaciones,
                idTurno: payload
            }
        }
    case SET_ALERTA_MODAL_DELETE: 
        return {
            ...state, 
            notificaciones: {
                ...state.notificaciones,
                idTurno: false
            }
        }
    case RESET_PORTAL_CONTEXT: 
        return notificaionInitialState
    
    default:
      return notificaionInitialState;
  }
};

export default notificacionesReducer